<template>
  <div class="mobile-cam-detail">
    <div class="mobile-player-viewport">
      <div class="video-container">
        <video
          id="videoElement"
          controls
          autoplay
          muted
          playsinline
          webkit-playsinline
          class="mobile-video-element"
        />
        <div v-if="!camDetail" class="video-loading-mask">
          <i class="el-icon-loading" />
          <p>正在建立安全加密连接...</p>
        </div>
      </div>

      <div class="video-status-bar">
        <span v-if="camDetail" :class="['status-badge', camDetail.onLive ? 'is-live' : 'is-playback']">
          <span class="pulse-dot" />
          {{ camDetail.onLive ? 'LIVE 实时画面' : '历史回放' }}
        </span>
        <span class="device-id">ID: {{ query.camId }}</span>
      </div>
    </div>

    <div class="device-info-section">
      <div class="info-left">
        <h2 class="device-title">{{ camDetail ? camDetail.camName : '摄像头监控' }}</h2>
      </div>
      <div class="info-right-actions">
        <el-button size="mini" icon="el-icon-share" type="primary" round @click="onShareCam">授权分享</el-button>
        <el-button size="mini" icon="el-icon-refresh" circle @click="refreshData" />
      </div>
    </div>

    <div class="history-archive-section">
      <div class="archive-header">
        <span class="archive-title"><i class="el-icon-folder-opened" /> 监控回放档案</span>

        <el-date-picker
          v-model="calendarDate"
          type="date"
          placeholder="选择日期"
          size="mini"
          :clearable="false"
          class="mobile-date-picker"
          @change="handleDateChange"
        />
      </div>

      <div class="current-date-display">
        <span class="date-text">当前查看：{{ getYearMonthDay(calendarDate) }}</span>
      </div>

      <div class="mobile-record-list">
        <div
          v-for="item in dataList"
          :key="item.recordId"
          class="mobile-record-item"
          @click="handlePlay(item.recordId)"
        >
          <div class="record-item-left">
            <div class="play-icon-box">
              <i class="el-icon-video-play" />
            </div>
            <div class="record-meta">
              <div class="record-time">{{ item.startTime }}</div>
              <div class="record-duration">时长: {{ item.duration }}秒</div>
            </div>
          </div>
          <i class="el-icon-arrow-right arrow-indicator" />
        </div>

        <el-empty v-if="!dataList.length" description="该日期暂无监控录像" :image-size="80" />
      </div>
    </div>

    <el-dialog
      title="授权给好友"
      :visible.sync="showCreateShareDialog"
      width="90%"
      custom-class="mobile-auth-dialog"
      append-to-body
    >
      <div class="share-box">
        <p class="share-tip">请选择有权查看此摄像头画面的好友：</p>
        <div class="user-select-list">
          <el-checkbox-group v-model="createShareForm.shareToList">
            <el-checkbox
              v-for="user in userContactList"
              :key="user.userIdStr"
              :label="user.username"
              border
              class="mobile-user-checkbox"
            >
              <div class="user-cell-wrapper">
                <el-avatar :size="20" icon="el-icon-user" />
                <span class="u-name">{{ user.username }}</span>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showCreateShareDialog = false" style="width: 45%">取消</el-button>
        <el-button type="primary" size="small" round style="width: 45%" @click="createShare">确认授权</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import flvjs from 'flv.js'
import { createShare, getCamDetail, getRecordByMonth, getRecordUrl } from '@/api/disk'
import { getUserContact } from '@/api/user'

export default {
  name: 'CamDetailMobile',
  data() {
    return {
      calendarDate: new Date(),
      query: {
        camId: '',
        yearMonth: '',
        yearMonthDay: ''
      },
      dataList: [],
      camDetail: null,
      showCreateShareDialog: false,
      userContactList: [],
      createShareForm: {
        albumType: 1,
        albumId: null,
        shareToList: []
      },
      flvPlayer: null
    }
  },
  created() {
    this.query.camId = this.$route.query.camId
    if (this.query.camId) {
      this.getData()
    } else {
      this.$message.error('参数错误')
      this.$router.go(-1)
    }
  },
  beforeDestroy() {
    // 移动端路由切换时必须销毁直播流实例，释放手机内存与解码器
    this.destroyFlvPlayer()
  },
  methods: {
    getData() {
      getCamDetail(this.query).then(resp => {
        if (resp.code === 0) {
          this.camDetail = resp.data
          // 如果后端返回了当日录像，则直接渲染
          if(resp.data.dayRecords) {
            this.dataList = resp.data.dayRecords
          }
          this.$nextTick(() => {
            if (this.camDetail.onLive) {
              this.initVideoPlayer(this.camDetail.liveUrl, true)
            } else {
              this.initVideoPlayer(this.camDetail.url, false)
            }
          })
        }
      })
    },
    refreshData() {
      this.destroyFlvPlayer()
      this.getData()
      this.$message.success('已刷新当前画面')
    },
    handleDateChange(date) {
      this.query.yearMonthDay = this.getYearMonthDay(date)
      getCamDetail(this.query).then(resp => {
        if (resp.code === 0) {
          this.camDetail = resp.data
          this.dataList = resp.data.dayRecords || []
          // 如果切换日期带有录像，自动载入新视频
          if (this.camDetail.url) {
            this.initVideoPlayer(this.camDetail.url, false)
          }
        }
      })
    },
    handlePlay(recordId) {
      getRecordUrl(recordId).then(resp => {
        if (resp.code === 0) {
          this.destroyFlvPlayer()
          this.initVideoPlayer(resp.data.url, false)
          // 手机端播放回放时，让屏幕平滑滚动回顶部视频区，提升操作连贯性
          window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    destroyFlvPlayer() {
      if (this.flvPlayer) {
        this.flvPlayer.pause()
        this.flvPlayer.unload()
        this.flvPlayer.detachMediaElement()
        this.flvPlayer.destroy()
        this.flvPlayer = null
      }
    },
    initVideoPlayer(videoUrl, live) {
      this.destroyFlvPlayer()
      const videoElement = document.getElementById('videoElement')
      if (!videoElement) return

      if (!live) {
        videoElement.src = videoUrl
        videoElement.load()
        return
      }

      if (!flvjs.isSupported()) {
        this.$message.error('当前设备浏览器不支持 FLV 直播流解码')
        return
      }

      this.flvPlayer = flvjs.createPlayer({
        type: 'flv',
        isLive: true,
        url: videoUrl,
        enableStashBuffer: false,
        hasAudio: true,
        hasVideo: true
      })
      this.flvPlayer.attachMediaElement(videoElement)
      this.flvPlayer.load()
      this.flvPlayer.play()

      // 移动端低延时追帧策略
      videoElement.addEventListener('progress', () => {
        if(!this.flvPlayer || !this.flvPlayer.buffered.length) return
        const end = this.flvPlayer.buffered.end(0)
        const delta = end - this.flvPlayer.currentTime
        if (delta > 8 || delta < 0) {
          this.flvPlayer.currentTime = end - 1
          return
        }
        videoElement.playbackRate = delta > 1.2 ? 1.15 : 1.0
      })
    },
    getYearMonthDay(date) {
      const year = date.getFullYear().toString().padStart(4, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    onShareCam() {
      this.createShareForm.albumId = this.camDetail.camId
      getUserContact(1).then(resp => {
        if (resp.code === 0) {
          this.userContactList = resp.data
          this.showCreateShareDialog = true
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    createShare() {
      createShare(this.createShareForm).then(resp => {
        this.$message.success('授权成功')
        this.showCreateShareDialog = false
      })
    }
  }
}
</script>

<style scoped>
.mobile-cam-detail {
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 40px;
}

/* 视频视口：严格的移动端 16:9 比例 */
.mobile-player-viewport {
  position: sticky;
  top: 0;
  width: 100%;
  background: #000;
  z-index: 100;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.video-container {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
}

.mobile-video-element {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.video-loading-mask {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 13px;
}
.video-loading-mask i { font-size: 24px; margin-bottom: 8px; }

/* 视频内底部状态栏 */
.video-status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #111;
  color: #fff;
}

.status-badge {
  display: flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
}
.is-live { background: #fef0f0; color: #f56c6c; }
.is-playback { background: #333; color: #bbb; }

.pulse-dot { width: 6px; height: 6px; border-radius: 50%; margin-right: 4px; background: currentColor; }
.is-live .pulse-dot { animation: pulse 1.5s infinite; }

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.4); opacity: 0.4; }
  100% { transform: scale(1); opacity: 1; }
}
.device-id { font-size: 11px; color: #888; }

/* 设备操作区块 */
.device-info-section {
  background: #fff;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}
.device-title { font-size: 16px; font-weight: bold; color: #222; margin: 0; }
.info-right-actions { display: flex; gap: 8px; }

/* 下半部分：档案列表 */
.history-archive-section {
  margin-top: 10px;
  background: #fff;
  padding: 14px 16px;
}

.archive-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.archive-title { font-size: 14px; font-weight: bold; color: #444; }
.archive-title i { color: #1a73e8; margin-right: 4px; }

/* 移动端轻量选择器重写 */
::v-deep .mobile-date-picker.el-input {
  width: 120px !important;
}

.current-date-display {
  background: #f1f5f9;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  color: #475569;
  font-weight: 600;
  margin-bottom: 12px;
}

/* 列表移动端单元格化 */
.mobile-record-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mobile-record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8fafc;
  border-radius: 10px;
  -webkit-tap-highlight-color: transparent;
}
.mobile-record-item:active {
  background: #edf2f7;
}

.record-item-left { display: flex; align-items: center; gap: 12px; }

.play-icon-box {
  width: 32px;
  height: 32px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  color: #1a73e8;
  font-size: 16px;
}

.record-time { font-size: 14px; font-weight: bold; color: #334155; }
.record-duration { font-size: 11px; color: #64748b; margin-top: 2px; }
.arrow-indicator { color: #cbd5e1; font-size: 14px; }

/* 好友授权移动端弹窗微调 */
::v-deep .mobile-auth-dialog {
  border-radius: 16px !important;
}
.user-select-list { max-height: 240px; overflow-y: auto; }
.mobile-user-checkbox {
  width: 100%;
  margin: 0 0 8px 0 !important;
  border-radius: 8px;
  padding: 8px 12px !important;
  box-sizing: border-box;
}
.user-cell-wrapper { display: flex; align-items: center; gap: 8px; }
.u-name { font-size: 13px; }
</style>
